export const getInstallingWebsocketUrl = integrations => {
  return integrations?.results?.find(integration => integration.websocket_url)?.websocket_url
}
